<template>
  <div>
    <el-input
      v-model.trim="mobileValue"
      size="large"
      class="login-mobile-input"
      :class="{ 'login-mobile-input__h5': isH5 }"
      maxlength="11"
      placeholder="请输入您的手机号"
      inputmode="numeric"
      tabindex="1"
      auto-complete="on"
      @input="handleInput"
    >
      <el-select
        slot="prepend"
        v-model="codeValue"
        placeholder=""
        :disabled="!!fixedCode"
        class="custom-select"
        :class="{ 'custom-select__h5': isH5 }"
        :popper-class="isH5 ? 'select-code-popper__h5' : 'select-code-popper'"
        :popper-append-to-body="true"
        @visible-change="onVisibleChange"
        @change="handleChangeCode"
      >
        <el-option-group
          v-for="group in areaCodeList"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.option"
            :key="item.id"
            :label="'+' + item.region_num"
            :value="item.region_num"
          >
            <div class="option-item-box">
              <span class="options-item-code">{{ "+" + item.region_num }}</span>
              <span class="options-item-name">{{ item.cn_name }}</span>
            </div>
          </el-option>
        </el-option-group>
        <div class="custom-caret-icon" slot="prefix">
          <!-- <img src="../../../assets/images/login/select-caret-up.png" alt="" /> -->
        </div>
      </el-select>
    </el-input>
    <div
      v-if="showModal"
      ref="letterList"
      class="letter-list-box"
      :class="{ 'letter-list-box__h5': isH5 }"
    >
      <div
        v-for="(item, index) in letterList"
        :key="index"
        class="letter-item"
        @click="handleClickLetter(item, index)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { uploadLiveLog } from "@saas/components/src/utils/log";
const letterData = [
  "#",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export default {
  props: {
    mobile: {
      type: String,
      default: "",
    },
    code: {
      type: [String, Number],
      default: "",
    },
    codeList: {
      type: Array,
      default: () => [],
    },
    fixedCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mobileValue: "",
      codeValue: "",
      showModal: false,
      isH5: isH5(),
      popperClass: "",
    };
  },
  computed: {
    letterList() {
      const list = this.areaCodeList
        .filter((item) => item.option.length !== 0)
        .map((item) => {
          return item.type;
        });
      return list;
    },
    areaCodeList() {
      const codeList = this.codeList || [];
      const list = letterData.map((item) => {
        return {
          label: item === "#" ? "选择国家和地区" : item,
          type: item,
          option: [],
        };
      });
      list.forEach((item) => {
        item.option = codeList.filter(
          (cItem) =>
            item.type.toLowerCase().indexOf(cItem.name_code.toLowerCase()) === 0
        );
      });
      return list.filter((item) => item.option.length !== 0);
    },
  },
  watch: {
    mobile: {
      handler(val) {
        this.mobileValue = val;
      },
      immediate: true,
    },
    code: {
      handler(val) {
        if (this.fixedCode) {
          this.codeValue = this.fixedCode + "";
          return;
        }
        if (val) {
          this.codeValue = val + "";
        } else {
          this.codeValue = "";
        }
      },
      immediate: true,
    },
    fixedCode: {
      handler(val) {
        if (val) {
          this.codeValue = val + "";
        } else {
          // this.codeValue = "";
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.popperClass = this.isH5
      ? "select-code-popper__h5"
      : "select-code-popper";
  },
  methods: {
    onVisibleChange(val) {
      this.showModal = val;
      if (val) {
        this.$nextTick(() => {
          const popper = document.querySelector("." + this.popperClass);
          popper && popper.appendChild(this.$refs.letterList);
        });
      }
    },
    handleClickLetter(item, index) {
      this.scrollToOption(index);
    },
    scrollToOption(index) {
      const dropdownEl = document.querySelector("." + this.popperClass);
      if (!dropdownEl) {
        return;
      }
      const optionEl = dropdownEl.querySelectorAll(`.el-select-group__title`)[
        index
      ];
      if (optionEl) {
        optionEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    handleKeydown(e) {
      let key = e.key;
      const keys = [".", "-", "+", "e", "E"];
      if (keys.includes(key)) {
        e.returnValue = false;
        return false;
      } else {
        return true;
      }
    },
    handleInput(val) {
      val = val.replace(/[^0-9]/g, "");
      this.mobileValue = val;
      this.$emit("update:mobile", this.mobileValue);
      this.$emit("change", this.mobileValue, this.codeValue + "");
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
    },
    handleChangeCode() {
      // 上传日志：切换区号
      uploadLiveLog({
        message: "切换区号",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "InputPhone",
          regionNum: this.codeValue,
        },
      }, true);
      
      this.$emit("update:code", this.codeValue + "");
      this.$emit("change", this.mobileValue, this.codeValue + "");
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-mobile-input ::v-deep {
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid #e8e8e9;
  .el-input-group__prepend {
    border: none;
    background-color: #fff;
  }
  .el-input__inner {
    border: none;
    color: $saas-text-color;
  }
  .el-select {
    width: 73px;
    position: relative;
    &:after {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      content: "";
      width: 1px;
      height: 16px;
      background: #e8e8e9;
      border-radius: 1px;
    }
    .el-input__inner {
      padding: 0;
      padding-left: 12px !important;
      color: #515350;
    }
    .el-input--suffix {
      .el-input__suffix {
        .el-input__icon {
          color: #515350;
        }
      }
    }
    .el-input--suffix.is-focus {
      .el-input__inner {
        color: #00c89d;
      }
      .el-input__suffix {
        .el-input__icon {
          color: #00c89d;
        }
      }
    }
  }
}
.login-mobile-input__h5 ::v-deep {
  border-radius: 0.32rem;
  .el-select {
    width: 1.9467rem;
    &:after {
      width: 0.0267rem;
      height: 0.4267rem;
    }
    .el-input__inner {
      padding: 0;
      padding-left: 0.32rem !important;
    }
  }
}
.select-code-popper {
  .el-select-group__wrap {
    padding-bottom: 0;
    &:after {
      display: none;
    }
    ::v-deep .el-select-group__title {
      font-size: 14px;
      color: #515350;
    }
  }
  .option-item-box {
    width: 300px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: $saas-text-color;
    span {
      display: inline-block;
    }
    .options-item-code {
      width: 56px;
    }
  }
  .el-select-dropdown__item {
    height: 30px;
    &.selected {
      .option-item-box {
        color: #00c89d;
        font-weight: normal;
      }
    }
  }
}
.select-code-popper__h5 {
  .el-select-group__wrap {
    padding-bottom: 0;
    &:after {
      display: none;
    }
    ::v-deep .el-select-group__title {
      font-size: 0.3733rem;
      color: #515350;
    }
  }
  .option-item-box {
    width: 8rem;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.3733rem;
    color: $saas-text-color;
    span {
      display: inline-block;
    }
    .options-item-code {
      width: 1.4933rem;
    }
  }
  .el-select-dropdown__item {
    height: 0.8rem;
    &.selected {
      .option-item-box {
        color: #00c89d;
        font-weight: normal;
      }
    }
  }
}

.letter-list-box {
  padding: 16px 0 10px 0;
  height: 432px;
  width: 20px;
  text-align: center;
  font-size: 12px;
  color: #515350;
  position: absolute;
  right: 10px;
  top: 0;
  .letter-item {
    height: 17px;
    cursor: pointer;
    &:hover {
      color: #00c89d;
    }
  }
}
.letter-list-box__h5 {
  padding: 0.48rem 0 0.2667rem 0;
  height: 10.8267rem;
  width: 0.32rem;
  font-size: 0.32rem;
  right: 0.44rem;
  .letter-item {
    height: 0.44rem;
  }
}
.custom-select ::v-deep {
  position: relative;
  .el-input__suffix {
    display: none;
  }
  .el-input {
    .el-input__prefix {
      left: 55px;
      width: 10px;
      height: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
    .custom-caret-icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 10px;
      height: 10px;
      background-image: url("../../../assets/images/login/select-caret-down.png");
      background-size: 10px 10px;
    }
    &.is-focus {
      .el-input__inner {
        color: #00c89d !important;
      }
      .custom-caret-icon {
        background-image: url("../../../assets/images/login/select-caret-up.png");
      }
    }
  }
}
.custom-select__h5 ::v-deep {
  .el-input {
    .el-input__prefix {
      left: 1.4667rem;
      width: 0.2667rem;
      height: 0.2667rem;
    }
    .custom-caret-icon {
      width: 0.2667rem;
      height: 0.2667rem;
      background-image: url("../../../assets/images/login/select-caret-down.png");
      background-size: 0.2667rem 0.2667rem;
    }
    &.is-focus {
      .custom-caret-icon {
        background-image: url("../../../assets/images/login/select-caret-up.png");
      }
    }
  }
}
</style>
<style lang="scss">
.select-code-popper {
  border-radius: 24px !important;
  overflow: hidden;
  .el-scrollbar {
    .el-select-dropdown__wrap {
      height: 432px;
      max-height: none;
    }
  }
}
.select-code-popper__h5 {
  border-radius: 0.64rem !important;
  overflow: hidden;
  .el-scrollbar {
    .el-select-dropdown__wrap {
      height: 10.8267rem;
      max-height: none;
    }
  }
}
</style>
